import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { BaseAuthenticatedComponent } from '@hm_app/shared/base-authenticated/base-authenticated.component';
import { NbRoleProvider } from '@nebular/security';
import { NbToastrService } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ngx-hm-update-profile',
  templateUrl: './hm-update-profile.component.html',
  styleUrls: ['./hm-update-profile.component.scss']
})
export class HmUpdateProfileComponent extends BaseAuthenticatedComponent implements OnInit {

  constructor(
    protected hmService: HappyMammaService,
    protected modalService: NgbModal,
    protected router: Router,
    protected toastrService: NbToastrService,
    protected roleProvider: NbRoleProvider
  ) { super(hmService, toastrService, roleProvider); }

  async ngOnInit() {
    await this.hmService.refreshUser(true);
    this.router.navigate(['/admin/dashboard']);
  }

}
